import { Component, OnInit } from '@angular/core';
import { App } from 'src/app/models/app';
import { ApplicationHubService } from 'src/app/services/application-hub.service';

@Component({
  selector: 'app-public-gateway',
  templateUrl: './public-gateway.component.html',
  styleUrls: ['./public-gateway.component.scss']
})
export class PublicGatewayComponent implements OnInit {

  constructor(private service: ApplicationHubService) { }

  Applications: App[] = [];

  Filter: 'production' | 'test' = 'production';
  Production_Applications: App[] = [];
  Test_Applications: App[] = [];

  Loading = false;
  

  ngOnInit(): void {

    this.Loading = true;

    this.service.get().subscribe((data) => {
      this.Applications = data;
      this.Production_Applications = this.Applications.filter(x => x.Production && x.RoleRequired == false);
      this.Test_Applications = this.Applications.filter(x => !x.Production && x.RoleRequired == false);
    });

    this.Loading = false;
  }

}
